import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PerfilUser from '../../resources/images/menu/perfil.png';
import MaskedInput from 'react-text-mask';
import Axios from 'axios';

export default function PerfilEditar() {
  const refInput = useRef();
  const { current } = refInput;
  const [user, setUser] = useState({});
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [imageUser, setImageUser] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const getUserData = () => {
    let user = JSON.parse(localStorage.getItem('user'))
    if(user.birth){
      let birth = user.birth.split('-');
      let day = birth[2].split(' ')[0];
      user.birth = day + '/' + birth[1] + '/' + birth[0];
    }

    if(user.phone){
      let ddd = user.phone.slice(0,2);
      let first = '';
      let end = '';

      if(user.phone.length === 11){
        first = user.phone.slice(2,7);
        end = user.phone.slice(7);
      } else {
        first = user.phone.slice(2,6);
        end = user.phone.slice(6);
      }
      user.phone = '(' + ddd + ')' + ' ' + first +'-'+end;

    }

    user.password = '';
    return user;
  };

  const selectImage = async () => {
    current.click();
  }

  const getBase64 = async (file) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      let imageUser = reader.result
      const image = JSON.stringify({"imagem": imageUser});
      try {
      var data = JSON.stringify({"imagem": image});
      var config = {
        method: 'post',
        url: 'https://api.yuzer.com.br/api/perfil/alterarfoto',
        headers: {
          'Content-Type': 'application/json'
        },
        data : data
      };
      Axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        localStorage.setItem('user', JSON.stringify(response.data));
        alert('Imagem atualizada!')
        history.push("/perfil");
      })
      .catch(function (error) {
        console.log(error);
      });


      // Axios({
      // method: 'post',
      // url: 'perfil/alterarfoto/',
      // headers: {
      //   'Content-Type': 'application/json'
      // },
      // data: image,
      // })
      // .then(function (response) {
      //   //handle success
      //   console.log(response.data);
      //   localStorage.setItem('user', JSON.stringify(response.data));
      //   alert('Imagem atualizada!')
      //   history.push("/perfil");
      // })
      // .catch(function (response) {
      //   //handle error
      //   console.log(response);
      // });

      setLoading(false);
      } catch (err) {
        console.log(err);
        alert('Ops, ocorreu um erro ao atualizar sua foto, por favor tente novamente.');
        setLoading(false);
        console.log(err.response);
      }
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
  }

  const updateImage = async(e) => {
    e.preventDefault()
    if (e.target.files[0]){
      try {
        // const upload = new FormData();
        // const imagedata = e.target.files[0];
        // upload.append('image', imagedata);
        let result = await getBase64(e.target.files[0]);

        // history.push("/perfil");

        // console.log(data);
        // localStorage.setItem('user', JSON.stringify(data));
        // alert('Imagem atualizada!')
        // history.push("/perfil");
        // setLoading(false);
      } catch (err) {
        console.log(err);
        alert('Ops, ocorreu um erro ao atualizar sua foto, por favor tente novamente.');
        setLoading(false);
        console.log(err.response);
      }
    }
  }

  const checkCep = async (e) => {
    
    if (e.target.value.length >= 9) {
      let cepPreenchido = e.target.value;
      try {
        let retorno = await Axios.get('cep/'+cepPreenchido.replace('-', ''));
        
        if (retorno.data.estado) {
          let cities = await getCidades(retorno.data.estado);
          let retornoCities = '';
          if (cities.length) {
            retornoCities = cities.filter((item) => item.city_name === retorno.data.localidade);
          }
          setForm({
            ...form,
            state: retorno.data.estado,
            city: retorno.data.localidade,
            zip_code: retorno.data.cep,
            street: retorno.data.logradouro,
            neighborhood: retorno.data.bairro
          })
        } else {
          setForm({
            ...form,
            zip_code: cepPreenchido
          })
        }
      } catch (err) {
        setForm({
          ...form,
          zip_code: cepPreenchido
        })
        console.log(err);
      }
    }
  }

  const getEstados = async () => {
    let {data} = await Axios.get('states');
    setEstados(data);

    return data;
  }

  const getCidades = async (state, statesSource) => {
    const source = statesSource || estados;
    let resultado = source.filter((item) => item.uf_initials === state);
    if (resultado.length) {
      let { data } = await Axios.get('uf-cities/uf/' + resultado[0].uf_code);
      setCidades(data);
      return data;
    }
    return [];
  }

  const apagarConta = async() => {
    let confirmar = window.confirm('Você tem certeza que deseja apagar sua conta?');
    if (confirmar === true) {
      console.log('apagar')
    } else {
      console.log('não apagar')
    }
  }
  const birth = (input) => {
    return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  }

  const phoneMask = (input) => {
    if (input && input.length >= 14) {
      return ['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    } else {
      return ['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    }
  }
  const cpf = (input) => {
    return [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-',/\d/,/\d/]
  }

  const cep = (input) => {
    return [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
  }

  const loadContent = async () => {
    let data = getUserData();
    try {
      const { data: fresh } = await Axios.get('perfil/me');
      if (fresh && fresh.image) {
        data = { ...data, image: fresh.image };
        localStorage.setItem('user', JSON.stringify({ ...JSON.parse(localStorage.getItem('user')), image: fresh.image }));
      }
    } catch (_) {}
    setForm(data);
    setUser(data);
    let states = await getEstados();
    await getCidades(data.state, states);
  }

  useEffect(() => {
    loadContent();

  }, []);

  const send = async (e) => {
    e.preventDefault();
    setLoading(true);
    let phone_unmask = form.phone;
    let birth_unmask = '';
    try {
      if(form.name === '') {
        alert('Preencha seu nome')
        setLoading(false);
        return false
      }

      if(form.email === '') {
        alert('Preencha seu e-mail')
        setLoading(false);
        return false
      }

      if(phone_unmask === null) {
        alert('Preencha seu telefone')
        setLoading(false);
        return false
      } else {
        phone_unmask = form.phone.replace(/[\D]/g, '');
      }

      if(form.birth){
        let birth = form.birth.split('/');
        birth_unmask = birth[2] + '-' + birth[1] + '-' + birth[0];
      }

      if (form.password) {
        if(form.password.length < 6) {
          alert('A senha precisa ter no mínimo 6 caracteres!')
          setLoading(false);
          return false
        }

        if(form.password !== form.passwordRepeat) {
          alert('O campo senha e repita a senha devem ser iguais!')
          setLoading(false);
          return false
        }
      }

      let payload = {
        status: 1,
        id: user.id,
        name: form.name,
        cpf: form.cpf,
        email: form.email,
        phone: phone_unmask,
        birth: birth_unmask,
        zip_code: form.zip_code,
        state: estados.filter((a) => a.uf_initials === form.state)[0].uf_initials,
        city: form.city
      }

      if (form.password) {
        payload.password = form.password;
      }

      if (form.image) {
        payload.image = form.image;
      }

      const { data } = await Axios.post('customers/update/'+user.id, payload)
      localStorage.setItem('user', JSON.stringify(data));
      setLoading(false);
      alert('Sucesso! Seus dados foram atualizados.');

      const directionarCarrinho = localStorage.getItem('direcionar_carrinho');
      if (directionarCarrinho) {
        history.push('/loja/add?product_id=' + directionarCarrinho);
        return;
      }
      const redirectTo = location.state?.redirectTo;
      redirectTo ? history.push(redirectTo) : history.goBack();

    } catch (err) {
      console.log(err);
      alert('Ops, ocorreu um erro ao efetuar o cadastro, por favor tente novamente.');
      setLoading(false);
      console.log(err.response);
    }
  };

  return (
    <div className="perfilAreaUser">
      <div className="perfilEditar content">
        <div className="editImageArea">
          <div className="menuPerfilArea">
            <div className="menuPerfil" style={{backgroundImage: `url(${user.image ? user.image : PerfilUser})`}}>
            </div>
          </div>
          <div className="editText" onClick={() => selectImage()}>
            Trocar foto
          </div>
          <input type="file" id="file" name="image"
          onChange={(b) => updateImage(b)} ref={refInput} style={{display: "none"}}/>
        </div>
      </div>
      <div className="formArea content">
        <form onSubmit={send}>
          <div className="ui-input-title">
            Seu nome
          </div>
          <input
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="ui-input"
            placeholder="Nome"
            type="text"
            required
          />
          <div className="ui-input-title">
            Seu melhor e-mail
          </div>
          <input
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="ui-input"
            placeholder="E-mail"
            type="email"
            disabled={true}
            required
          />
          <div className="ui-input-title">
            Seu telefone
          </div>
          <MaskedInput
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            mask={phoneMask}
            className="ui-input"
            placeholder="Telefone"
            guide={false}
          />
          <div className="ui-input-title">
            Seu Aniversário
          </div>
          <MaskedInput
            value={form.birth}
            onChange={(e) => setForm({ ...form, birth: e.target.value })}
            mask={birth}
            className="ui-input"
            placeholder="Nascimento"
            guide={false}
          />
          <div className="ui-input-title">
            Seu CPF
          </div>
          <MaskedInput
            value={form.cpf}
            onChange={(e) => setForm({ ...form, cpf: e.target.value })}
            mask={cpf}
            className="ui-input"
            placeholder="CPF"
            disabled={false}
            guide={false}
          />
          <div className="ui-input-title">
            Seu CEP
          </div>
          <MaskedInput
            value={form.zip_code}
            onChange={(e) => checkCep(e)}
            mask={cep}
            required
            className="ui-input"
            placeholder="CEP"
            guide={false}
          />
          <div className="ui-input-title">
            Seu Estado
          </div>
          <select
            value={form.state}
            onChange={(e) => {
              setForm({ ...form, state: e.target.value})
              getCidades(e.target.value)
            }}
            className="ui-input">
            <option value="" disabled>Selecione um estado</option>
            {estados.map((item, index) => (
              <option key={index} value={item.uf_initials}>{item.uf_initials}</option>
            ))}
          </select>
          <div className="ui-input-title">
            Sua Cidade
          </div>
          <select
            value={form.city}
            onChange={(e) => setForm({ ...form, city: e.target.value })}
            className="ui-input">
            <option value="" disabled>Selecione uma cidade</option>
            {cidades.map((item, index) => (
              <option key={index} value={item.city_name}>{item.city_name}</option>
            ))}
          </select>

          <div className="ui-input-title">
            Sua senha
          </div>
          <input
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="ui-input"
            placeholder="Preencha caso deseja alterar"
            type="password"
          />
          <div className="ui-input-title">
            Repita sua senha
          </div>
          <input
            value={form.passwordRepeat}
            onChange={(e) => setForm({ ...form, passwordRepeat: e.target.value })}
            className="ui-input"
            placeholder="Repita a senha"
            type="password"
          />
          <button type="submit" className="attButton" disabled={loading}>
            Atualizar
          </button>
          {/* <div className="apagarConta" onClick={() => apagarConta()}>
            Apagar minha conta
          </div> */}
        </form>
      </div>
    </div>
  )
}
